import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import { put, fork, take, select } from 'redux-saga/effects';
import * as actions from './actions';


function* init() {
  while (true) {
    const { localId } = yield take(actions.INIT.BEGIN);
    const { statusOptions } = yield select(state => state.configuration.project.editor.status);
    const value = cloneDeep(find(statusOptions, x => x.$$localId === localId) || { invalid: true, value: {} });
    yield put(actions.init.end({ selectedStatus: value }));
  }
}

function* resetChanges() {
  while (true) {
    yield take(actions.RESET_CHANGES.BEGIN);
    const {
      statuses,
      currentStatus: selectedStatus,
       } = yield select(state => state.configuration.project.editor.status);
    const statusValue = find(statuses, x => x.id === selectedStatus.value.id);
    const value = cloneDeep(statusValue);
    yield put(actions.resetChanges.end({ value }));
  }
}


export default function* currentStatus() {
  yield fork(init);
  yield fork(resetChanges);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/status/currentStatus/saga.js